import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddAllowedDomainRPC } from "./addAllowedDomainRPC";

export class AddAllowedDomainRPCClientImpl extends AddAllowedDomainRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddAllowedDomainRPC.Request): Promise<LeoRPCResult<AddAllowedDomainRPC.Response, AddAllowedDomainRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/AddAllowedDomain",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddAllowedDomainRPC.ResponseDTO,
      AddAllowedDomainRPC.Errors.ErrorsDTO,
      AddAllowedDomainRPC.Response,
      AddAllowedDomainRPC.Errors.Errors
    >(
      response,
      "email-cycle/AddAllowedDomain",
      AddAllowedDomainRPC.Response.fromDTO,
      AddAllowedDomainRPC.Errors.fromDTO
    );
  }
}
